import { useCallback } from 'react';

import { log } from 'src/app/utils/logging';
import { useSendEmailVerificationEmailMutation } from 'src/graphql/generated';

export const useResendEmail = () => {
  const [sendEmailVerificationEmail] = useSendEmailVerificationEmailMutation();

  const resendEmail = useCallback(async () => {
    try {
      const { data } = await sendEmailVerificationEmail();
      if (data?.sendEmailVerificationEmail?.success) {
        return null;
      }
      throw new Error(
        `User email is not successfully resent as response has success value ${data?.sendEmailVerificationEmail?.success}`,
      );
    } catch (error) {
      log.error('UserEmailResend | Error Requesting User Email Resend', {
        error,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendEmailVerificationEmail]);

  return {
    resendEmail,
  };
};
